import type {
  ApplicationUserData,
  PersonalInfoSnapshot,
  ResidentApplicationData,
} from '@/types/application'
import type { ApplicationLayerData } from '../types/application'

function text(value: unknown) {
  if (value == null) return ''
  return String(value).trim()
}

export function getPersonalInfoSnapshot(
  application: ResidentApplicationData | ApplicationLayerData | null | undefined,
): PersonalInfoSnapshot | null {
  const raw = application?.personal_info_snapshot
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    return raw as PersonalInfoSnapshot
  }
  return null
}

export function hasPersonalInfoSnapshot(
  application: ResidentApplicationData | ApplicationLayerData | null | undefined,
): boolean {
  return getPersonalInfoSnapshot(application) != null
}

/** About Yourself personal block — immutable snapshot when present, else live columns. */
export function aboutYourselfPersonalDisplay(
  application: ResidentApplicationData | ApplicationLayerData | null | undefined,
): PersonalInfoSnapshot & { suffix?: string } {
  const snapshot = getPersonalInfoSnapshot(application)
  const user = (application?.user_data ?? {}) as ApplicationUserData

  if (snapshot) {
    return {
      ...snapshot,
      suffix: user.suffix ?? '',
    }
  }

  return {
    first_name: text(user.first_name || application?.first_name || application?.applicant_first_name),
    middle_name: text(user.middle_name || application?.middle_name),
    last_name: text(user.last_name || application?.last_name || application?.applicant_last_name),
    suffix: text(user.suffix),
    email: text(user.email || application?.email || application?.applicant_email),
    mobile_no: text(user.mobile_no || application?.mobile_no || application?.applicant_mobile_no),
    shared_phone_no: text(user.shared_phone_no || application?.shared_phone_no),
    birthdate: text(application?.birthdate),
    security_number: text(application?.security_number),
    communication_preference: text(application?.communication_preference),
  }
}

export function aboutYourselfPersonalUserData(
  application: ResidentApplicationData | ApplicationLayerData | null | undefined,
): ApplicationUserData {
  const personal = aboutYourselfPersonalDisplay(application)
  return {
    first_name: personal.first_name,
    middle_name: personal.middle_name,
    last_name: personal.last_name,
    suffix: personal.suffix,
    email: personal.email,
    mobile_no: personal.mobile_no,
    shared_phone_no: personal.shared_phone_no,
  }
}
